import * as Sentry from '@sentry/browser';

import {
  FormPayload,
  PayLoadValue,
  PreprocessorConfiguration,
  TokenizerV1PreprocessorParameters,
} from '@cashier/cashier-model';

import { DataConverter } from './dataConverter';

export const TokenizerV1Service = {
  filterPayload(formPayload: FormPayload): FormPayload {
    const { token, cardMask, ...rest } = formPayload;

    return rest;
  },
  async tokenizeCredentials(
    payload: { [name: string]: { value: PayLoadValue } },
    preprocessor: PreprocessorConfiguration,
  ): Promise<{ token: string; cvv: string; cardHolder: string }> {
    try {
      const { preprocessorUrl } = preprocessor.parameters;
      const credentials = DataConverter.toAuthToken(
        preprocessor.parameters as TokenizerV1PreprocessorParameters,
      );
      const cardData = DataConverter.toTokenizePayload(payload);

      const response = await fetch(preprocessorUrl, {
        method: 'POST',
        headers: {
          Authorization: `Basic ${credentials}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cardData),
      });

      if (!response.ok) {
        throw new Error(
          `Tokenization failed: ${response.status} ${response.statusText}`,
        );
      }

      const result = await response.json();

      if (!result.token) {
        throw new Error('No token received from tokenizer service');
      }

      return {
        token: result.token,
        cvv: String(payload.cvv?.value),
        cardHolder: String(payload.cardHolder?.value),
      };
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          error,
        },
      });

      throw error;
    }
  },

  async getPreprocessedAttributes(
    payload: { [name: string]: { value: PayLoadValue } },
    isAccountUsed: boolean,
    preprocessor: PreprocessorConfiguration,
  ): Promise<{ token?: string; cardMask?: string; cvv: string }> {
    let attributes = {};

    if (payload.cardMask && payload.creditcardNumber) {
      attributes = {
        ...attributes,
        cardMask: DataConverter.toMaskedCardNumber(
          payload.creditcardNumber.value as string,
        ),
      };
    }

    if (isAccountUsed) {
      return { ...attributes, cvv: String(payload.cvv?.value) };
    }

    return {
      ...attributes,
      ...(await this.tokenizeCredentials(payload, preprocessor)),
    };
  },
};
